module.exports = __webpack_public_path__ + "img/7.8cb9600b.png";